module.exports = __webpack_public_path__ + "static/img_4771-78e7e8ccf3f79c0d419b26d8651e56b2.webp";